import { LucideIcon, Map, BookOpen, Scroll, Users, Sword, Image, Terminal, Shield, Home, Compass, Globe, FileText, Award, Crown, MapPin, Newspaper, Gavel, Palette, Calendar } from 'lucide-react';

export const APP_NAME = "Games no Linux";
export const DISCORD_URL = "https://discord.gg/gamesnolinux";

export interface NavItem {
  label: string;
  path?: string;
  icon: LucideIcon;
  subItems?: { label: string; path: string; icon: LucideIcon; description?: string }[];
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Início', path: '/', icon: Home },
  { label: 'Guia', path: '/start', icon: Compass },
  { label: 'Mapa', path: '/map', icon: Map },

  { 
    label: 'Comunidade', 
    path: '/community',
    icon: Users,
    subItems: [
      { label: 'Galeria', path: '/gallery', icon: Image, description: 'Screenshots e arte' },
      { label: 'Regras do Servidor', path: '/rules', icon: Gavel, description: 'Código de conduta oficial' },
      { label: 'Skins', path: '/skins', icon: Palette, description: 'Catálogo de personalização' },
      { label: 'Eventos e Rank', path: '/events', icon: Calendar, description: 'Eventos e Ranking de Apoiadores' },
      { label: 'Patrocinadores Oficiais', path: '/sponsors', icon: Award, description: 'Nossos apoiadores oficiais' },
    ]
  },
  { 
    label: 'Hytale Notícias',
    icon: Newspaper,
    subItems: [
      { label: 'Blog', path: '/blog', icon: BookOpen, description: 'Artigos e lore' },
      { label: 'Atualizações', path: '/updates', icon: FileText, description: 'Changelog e patches' },
    ]
  },
];